let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g0waE")).then(() => parcelRequire('7xb48'));